import { parseDateOnly, toDateInputValue } from "./dateUtils";

const ALL_STATUS_CALCULO_CODES = [0, 1, 2, 3, 4];

function toDateOnly(value) {
  return parseDateOnly(value);
}

export function buildSuggestedRecalculoPeriod(start, end) {
  const today = toDateOnly(new Date());
  const startDate = toDateOnly(start);
  const endDate = toDateOnly(end);

  if (startDate) {
    const cappedEnd = endDate && today && endDate < today ? endDate : today;
    if (cappedEnd && startDate <= cappedEnd) {
      return {
        de: toDateInputValue(startDate),
        ate: toDateInputValue(cappedEnd),
      };
    }
  }

  const fallbackEnd = today || new Date();
  const fallbackStart = new Date(fallbackEnd.getTime());
  fallbackStart.setDate(fallbackEnd.getDate() - 29);

  return {
    de: toDateInputValue(fallbackStart),
    ate: toDateInputValue(fallbackEnd),
  };
}

export function buildRecalculoPresetFromTable(table, source = "tabelas_frete", extras = {}) {
  if (!table || !table.id) return null;

  return {
    key: `frete-tabela-${table.id}-${Date.now()}`,
    origem: source,
    tabelaId: table.id,
    tabelaNome: table.nome || null,
    transportadoraId: table.idTransportadora || table.transportadoraId || null,
    transportadoraNome: table.transportadoraNome || table.transportadora || null,
    periodoSugerido: buildSuggestedRecalculoPeriod(table.dataValIni, table.dataValFim),
    statusMode: "all",
    ...extras,
  };
}

export function buildRecalculoPreviewRequestFromTable({ empresaId, table }) {
  if (!empresaId || !table || !table.id) return null;

  const periodoSugerido = buildSuggestedRecalculoPeriod(table.dataValIni, table.dataValFim);
  const transportadoraId = table.idTransportadora || table.transportadoraId || null;

  return {
    previewEndpoint: "/recalculo/nfe/preview",
    body: {
      embarcadorId: empresaId,
      transportadoraIds: transportadoraId ? [transportadoraId] : undefined,
      statusCalculo: ALL_STATUS_CALCULO_CODES,
      dataEmissaoNFeDe: periodoSugerido.de || undefined,
      dataEmissaoNFeAte: periodoSugerido.ate || undefined,
    },
    canExecute: true,
  };
}
